<IziGrid class="setting-timer">
  <IziCol>
    <span class="total-timne">Total time:</span>
    <Dropdown
      v-model="totalTime"
      :options="timer"
      optionLabel="name"
      @change="selectTimer"
    >
      <template #value="slotProps">{{ slotProps.value.value }}</template>
      <template #option="slotProps">{{ slotProps.option.value }}</template>
    </Dropdown>
    <span class="minutes">minutes</span>
  </IziCol>
  <IziCol>
    <div class="p-field-radiobutton">
      <RadioButton
        id="option1"
        name="option1"
        value="auto"
        v-model="secondPerQuestion"
        :disabled="disabledAuto"
      />
      <label for="option1">Auto-set second per question</label>
    </div>
  </IziCol>
  <IziCol>
    <div class="p-field-radiobutton">
      <RadioButton
        id="option2"
        name="option2"
        value="manually"
        v-model="secondPerQuestion"
      />
      <label for="option2">Manually set second per question</label>
    </div>
  </IziCol>
</IziGrid>